import { getConsumerLandingRouteInfo } from './getConsumerLandingRouteInfo';

export const navigateToConsumerLandingPage = () => {
  const { component, params } = getConsumerLandingRouteInfo();

  ADV.util.Router.go2(component, params);
};
